import React from 'react';
import uuid from 'uuid';

const TextWithUpArrow = (props) => {
  const { text, id = uuid() } = props;
  return (
    <div className="value-container arrow-container">
      <div className="arrow-up" />
      <div id={id} className="digit-value">{text}</div>
    </div>
  );
};

export default TextWithUpArrow;
